import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addExercisePropertyButtonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  avatarWrapper: {
    paddingBottom: '16px',
    '& img': {
      maxWidth: '100px',
      maxHeight: '100px',
    },
  },
  uploadFileButton: {
    height: '32px',
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: '4px',
    '& svg': {
      marginRight: '8px',
    },
  },
}));
